/* Pikalo DE – fiche produit (copie visuelle Miloubo, 03/11/2026).
   Complète bb-de.js sans le modifier : compteur et vignettes de la galerie (photos à 88 % sur mobile, comme Miloubo),
   et bouton « Alle Bewertungen ansehen » de la section avis. */
(function () {
  'use strict';
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function initGal() {
    var tr = document.querySelector('.bbp-f [data-bb-track]'); if (!tr) return;
    var slides = qa('.bb-gal__slide', tr);
    var cnt = document.querySelector('.bbp-f [data-bb-gal-count]');
    var th = qa('.bbp-f [data-bb-thumb]');
    var vign = document.querySelector('.bbp-f [data-bbp-vign]');
    var last = -1;
    function idx() {
      var mid = tr.scrollLeft + tr.clientWidth / 2, best = 0, d = 1e9;
      slides.forEach(function (s, i) {
        var c = (s.offsetLeft - tr.offsetLeft) + s.offsetWidth / 2, dd = Math.abs(c - mid);
        if (dd < d) { d = dd; best = i; }
      });
      if (tr.scrollLeft <= 2) best = 0;
      return best;
    }
    function upd() {
      var i = idx();
      if (cnt) cnt.textContent = (i + 1) + ' / ' + slides.length;
      th.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      [i + 1, i + 2].forEach(function (n) { var im = slides[n] && slides[n].querySelector('img'); if (im) im.loading = 'eager'; });
      if (i !== last && vign && th[i]) {
        var b = th[i], l = b.offsetLeft - vign.offsetLeft;
        if (l < vign.scrollLeft || l + b.offsetWidth > vign.scrollLeft + vign.clientWidth) vign.scrollTo({ left: Math.max(0, l - 8), behavior: 'smooth' });
      }
      last = i;
    }
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    tr.addEventListener('scroll', function () { raf(function () { raf(upd); }); }, { passive: true });
    th.forEach(function (b, n) {
      b.addEventListener('click', function () {
        var s = slides[n]; if (!s) return;
        tr.scrollTo({ left: (s.offsetLeft - tr.offsetLeft) - (tr.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
      });
    });
    raf(upd);
  }

  function initAvis() {
    qa('[data-bbp-avis-plus]').forEach(function (b) {
      b.addEventListener('click', function () {
        var w = b.closest('[data-bbp-avis]'); if (w) w.classList.add('is-tout');
      });
    });
  }

  /* Bouton d'achat : comme Miloubo, seul le prix payé (« In den Warenkorb – 39,90 € »), sans le prix barré que bb-de.js ajoute. */
  function initLabels() {
    qa('.bbp-f [data-bb-atc-label]').forEach(function (el) {
      function fix() { if (el.querySelector('s')) el.innerHTML = el.innerHTML.replace(/<s>[^<]*<\/s>(&nbsp;|\u00a0|\s)*/g, ''); }
      fix();
      if ('MutationObserver' in window) new MutationObserver(fix).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function boot() { initGal(); initAvis(); initLabels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
